import { useSnackbar as ReactUseSnackbar } from 'react-simple-snackbar'

interface IUseSnackbar {
  position: "bottom-left" | "bottom-right" | "top-left" | "top-right"
}

const useSnackbar = (optns?: IUseSnackbar) => ReactUseSnackbar(optns)

export default useSnackbar;